// admin API 呼び出しの共通処理。window.fetch を包み、全画面の API 呼び出しに一括で適用する。
// - API 宛ては Cookie(セッション)を必ず送る（credentials 未指定なら include。ローカルは画面とAPIが別ポートのため）
// - API が 401（未ログイン/セッション切れ）を返したら onUnauthorized。ログインAPI自体の 401 は対象外
const LOGIN_PATH = "/api/login/";

export function createApiFetch(origFetch, apiBase, onUnauthorized) {
  const apiPrefix = `${apiBase}/api/`;
  return async (input, init) => {
    const url = typeof input === "string" ? input : input?.url || "";
    const isApi = !!apiBase && url.startsWith(apiPrefix);
    const opts = isApi ? { ...init, credentials: init?.credentials ?? "include" } : init;
    const res = await origFetch(input, opts);
    if (isApi && res.status === 401 && !url.startsWith(`${apiBase}${LOGIN_PATH}`)) {
      onUnauthorized();
    }
    return res;
  };
}

// ブラウザに設置：401 ならログイン情報を消してログイン画面へ（ログイン画面にいる時は何もしない）
export function installApiFetch() {
  const apiBase = process.env.REACT_APP_API_URL;
  const orig = window.fetch.bind(window);
  window.fetch = createApiFetch(orig, apiBase, () => {
    ["isLoggedIn", "isSuperuser", "isStaff", "username"].forEach((k) => localStorage.removeItem(k));
    if (window.location.pathname !== "/login") window.location.replace("/login");
  });
}
